module.exports = __webpack_public_path__ + "static/media/gabriel_aboutme.719f9b42.jpg";